import styled from "styled-components";

export const DateContainer = styled.div`
  & > div:first-child {
    border: none;
    box-shadow: none;

    height: 40px;
    background-color: ${({ theme }) => theme.bg.primary};
    border-radius: 8px;
    box-sizing: border-box;

    & > *:nth-child(3) {
      border-radius: 8px;
    }
  }

  .date-picker__control {
    height: 40px;
    background-color: ${({ theme }) => theme.bg.primary};
    box-sizing: border-box;
    border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;
    border: none;
    width: 100%;

    &:focus {
      outline: none;
    }
  }

  .time-picker__control {
    height: 40px;
    background-color: ${({ theme }) => theme.bg.primary};
    box-sizing: border-box;
    border: none;
    width: 100%;

    &:focus {
      outline: none;
    }
  }

  .time-picker__single-value {
    color: ${({ theme }) => theme.text.input};
    font-size: 13.3333px;
  }

  .date-picker__single-value {
    color: ${({ theme }) => theme.text.input};
    font-size: 13.3333px;
  }

  svg {
    color: ${({ theme }) => theme.text.input};
  }
`;
